import { call, put, select, takeLatest } from 'typed-redux-saga'
import { errorHandler, loadersSlice, gridSlice } from 'Modules'
import { RequestParams } from 'Models'
import { FrontUrls } from 'Constants/FrontUrls'
import { routerActions } from 'connected-react-router'
import {
	rbidosAccessSlice,
	rbidosAccessSelector,
	rbidosAgentNS,
	rbidosAgentSlice,
	rbidosAgentApi,
	showCustomErrors,
	rbidosAgentSelector,
} from 'Pages/registry_business_access_neo'

function* getListAgent(action?: rbidosAgentNS.GetListAgent) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear, callback } = action.payload
		const { page, per_page, query, ...fields } = params
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		if (clear) {
			yield* put(rbidosAgentSlice.actions.clearListAgent())
		}

		const res = yield* call(rbidosAgentApi.getAllAgents, requestParams)
		if (!clear) {
			const oldAgents = yield* select(rbidosAgentSelector.getListAgent)
			res.results = oldAgents.concat(res.results)
		}
		yield* put(rbidosAgentSlice.actions.setListAgent(res))
		yield* put(rbidosAgentSlice.actions.setRequestParamsListAgent(requestParams))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* getAllListAgent(action?: rbidosAgentNS.GetAllListAgent) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear, callback } = action.payload
		const { page, per_page, query, ...fields } = params
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		if (clear) {
			yield* put(rbidosAgentSlice.actions.clearAllListAgent())
		}

		const res = yield* call(rbidosAgentApi.getAllAgents, requestParams)
		if (!clear) {
			const oldAgents = yield* select(rbidosAgentSelector.getAllListAgent)
			res.results = res.results.concat(oldAgents)
		}
		yield* put(rbidosAgentSlice.actions.setAllListAgent(res))
		yield* put(rbidosAgentSlice.actions.setRequestParamsAllListAgent(requestParams))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* getAccessAgent(action: rbidosAgentNS.GetAccessAgent) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear, callback } = action.payload
		const { page, per_page, query, ...fields } = params
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		const currentRequest = yield* select(rbidosAccessSelector.getCurrentRequest)
		if (clear) {
			yield* put(rbidosAgentSlice.actions.clearAccessAgent())
			yield* put(rbidosAccessSlice.actions.clearAll())
		}

		requestParams.company_id = currentRequest?.company_id.toString()
		const res = yield* call(rbidosAgentApi.getAllAgents, requestParams)
		yield* put(rbidosAgentSlice.actions.setAccessAgents(res))
		yield* put(rbidosAgentSlice.actions.setRequestParamsAccessAgent(requestParams))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* getOneAgent(action: rbidosAgentNS.GetOneAgent) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(rbidosAgentApi.getOneAgent, action.payload)
		yield* put(rbidosAgentSlice.actions.setOneAgent(res))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* createOneAgent(action: rbidosAgentNS.CreateOneAgent) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(rbidosAgentApi.createOneAgent, action.payload)
		yield* put(rbidosAgentSlice.actions.setNewAgent(res))
		yield* put(routerActions.push(FrontUrls.cabinet_redesign.registry_business_access_neo_modal))
	} catch (error) {
		yield* call(showCustomErrors, error, false)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* updateOneAgent(action: rbidosAgentNS.UpdateOneAgent) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(rbidosAgentApi.updateOneAgent, action.payload.id, action.payload.data)
		yield* put(rbidosAgentSlice.actions.setOneAgent(res))
		yield* call(getListAgent)
	} catch (error) {
		yield* call(showCustomErrors, error, true)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* getIdentificationPoints(action: rbidosAgentNS.GetIdentificationPoints) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(rbidosAgentApi.getIdentificationPoints)
		yield* put(rbidosAgentSlice.actions.setIdentificationPoints(res))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* rbidosAgentSaga() {
	yield* takeLatest(rbidosAgentSlice.actions.getListAgent.type, getListAgent)
	yield* takeLatest(rbidosAgentSlice.actions.getAllListAgent.type, getAllListAgent)
	yield* takeLatest(rbidosAgentSlice.actions.getAccessAgent.type, getAccessAgent)
	yield* takeLatest(rbidosAgentSlice.actions.getOneAgent.type, getOneAgent)
	yield* takeLatest(rbidosAgentSlice.actions.createOneAgent.type, createOneAgent)
	yield* takeLatest(rbidosAgentSlice.actions.updateOneAgent.type, updateOneAgent)
	yield* takeLatest(rbidosAgentSlice.actions.getIdentificationPoints.type, getIdentificationPoints)
}
